<mat-toolbar>
    <mat-toolbar-row color="primary">
        <h3>You have been Idle!</h3>
    </mat-toolbar-row>
    <mat-toolbar-row>
        <span> You will time out in -- seconds!</span>
    </mat-toolbar-row>
    <mat-toolbar-row>
        <div>
            <button type="button" matInput (click)="logout()">Logout</button>
            <button type="button" (click)="stop()" matInput>Stya</button>
        </div>
    </mat-toolbar-row>
</mat-toolbar>